const TOAST_ID = 'dxh-global-toast';
const DEFAULT_DURATION_MS = 3000;

/**
 * 全局轻提示（3 秒自动消失），可在任意模块调用（播放页、上传页等）。
 */
export function showGlobalToast(message, durationMs = DEFAULT_DURATION_MS) {
  if (!message || typeof document === 'undefined') return;

  let toast = document.getElementById(TOAST_ID);
  if (!toast) {
    toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:calc(72px + env(safe-area-inset-bottom, 0px))',
      'transform:translateX(-50%)',
      'z-index:99999',
      'max-width:min(88vw, 360px)',
      'padding:12px 18px',
      'border-radius:12px',
      'background:rgba(20,20,24,0.92)',
      'color:#fff',
      'font-size:14px',
      'line-height:1.45',
      'text-align:center',
      'box-shadow:0 8px 24px rgba(0,0,0,0.28)',
      'pointer-events:none',
      'opacity:0',
      'transition:opacity 0.25s ease',
    ].join(';');
    document.body.appendChild(toast);
  }

  if (toast._hideTimer) {
    clearTimeout(toast._hideTimer);
    toast._hideTimer = null;
  }

  toast.textContent = message;
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
  });

  toast._hideTimer = setTimeout(() => {
    toast.style.opacity = '0';
    toast._hideTimer = null;
  }, durationMs);
}
